import React from "react";
import { API, getToken } from "@/api";
import { toast } from "sonner";

export const fdate = (s) => (s ? new Date(String(s).slice(0, 10) + "T12:00:00").toLocaleDateString("fr-FR") : "—");
export const eur = (v) => `${(Number(v) || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
export const PILL = { draft: "status-inactive", active: "status-active", ended: "status-pending" };
export const LEVEL = { urgent: "border-[#E60000] text-[#E60000] bg-[#FEF2F2]", warn: "border-[#D97706] text-[#B45309] bg-[#FFFBEB]", info: "border-[#002FA7] text-[#002FA7] bg-[#EFF3FF]" };

export const emptyContract = (salarieId, sal) => ({
  salarie_id: salarieId, type: "cdi", poste: sal?.poste || "", classification: "", convention_collective: "", date_debut: new Date().toISOString().slice(0, 10),
  date_fin: "", motif: "", periode_essai_fin: "", temps_travail: "full", heures_hebdo: 35, salaire_brut_mensuel: "", lieu_travail: "", lieu_signature: "",
  avantages: "", clauses: "", signed_at: "", status: "draft", end_previous: false,
});

export const toForm = (c) => ({ ...emptyContract(c.salarie_id), ...Object.fromEntries(Object.entries(c).filter(([k]) => k in emptyContract("")).map(([k, v]) => [k, v ?? ""])), status: c.status });

export async function openPdf(path, name) {
  try {
    const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
    if (!res.ok) throw new Error();
    const url = URL.createObjectURL(await res.blob());
    window.open(url, "_blank");
  } catch { toast.error(`PDF indisponible${name ? ` (${name})` : ""}`); }
}

export function Field({ label, children, className = "" }) {
  return <div className={`space-y-1 ${className}`}><div className="text-[10px] uppercase tracking-wider font-semibold text-[#495057]">{label}</div>{children}</div>;
}

export function Info({ label, value, testid }) {
  return <div data-testid={testid}><div className="text-[10px] uppercase tracking-wider text-[#868E96]">{label}</div><div className="text-sm font-semibold">{value || "—"}</div></div>;
}
